import { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

import { Stack, Typography, Divider } from "@mui/material";

export default function Main({ apex_id }) {
  const navigate = useNavigate();

  const [loading, set_loading] = useState(true);
  const [error, set_error] = useState();

  const [fqdns, set_fqdns] = useState();

  const sx = {
    wrapper: { width: 1 },
  };

  useEffect(() => {
    axios({
      method: "post",
      url: `${process.env.REACT_APP_BE_URL}/fqdns`,
      data: { apex_id },
    })
      .then((res) => {
        set_fqdns(res.data.fqdns);
      })
      .catch((err) => set_error(err.response.data))
      .finally(() => set_loading(false));
  }, [apex_id]);

  if (loading) return <Typography>loading...</Typography>;
  if (error) return <Typography>{error}</Typography>;
  return (
    <Stack sx={sx.wrapper} spacing={2}>
      <Controls />
      <List fqdns={fqdns} />
    </Stack>
  );
}

function Controls() {
  const sx = { wrapper: { width: 1, justifyContent: "space-between" } };

  return (
    <Stack direction="row" spacing={1} sx={sx.wrapper}>
      <Stack direction="row" spacing={1}>
        <Typography>DATE</Typography>
        <Typography>SORT BY</Typography>
      </Stack>

      <Stack direction="row" spacing={1}>
        <Typography>COMPARE</Typography>
        <Typography>EXPORT</Typography>
      </Stack>
    </Stack>
  );
}

function List({ fqdns }) {
  const sx = {
    wrapper: { backgroundColor: "", border: "1px solid lightgrey" },
  };

  return (
    <Stack sx={sx.wrapper} divider={<Divider flexItem />}>
      {fqdns.map((e, i) => (
        <Typography key={i}>{e}</Typography>
      ))}
    </Stack>
  );
}
